import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["children", "className"];
import { cloneElement, forwardRef, isValidElement } from 'react';
import { Render, Provider, Container, useStore } from 'react-login-page';
import { Email } from "./control/Email.js";
import { Password } from "./control/Password.js";
import { Submit } from "./control/Submit.js";
import { Reset } from "./control/Reset.js";
import { ButtonAfter } from "./control/ButtonAfter.js";
import { Logo } from "./control/Logo.js";
import { Title } from "./control/Title.js";
import { Banner } from "./control/Banner.js";
import './index.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export * from 'react-login-page';
export * from "./control/Email.js";
export * from "./control/ButtonAfter.js";
export * from "./control/Password.js";
export * from "./control/Submit.js";
export * from "./control/Reset.js";
export * from "./control/Title.js";
export * from "./control/Logo.js";
export * from "./control/Banner.js";
var RenderLogin = () => {
  var {
    blocks = {},
    extra = {},
    data
  } = useStore();
  var {
    fields,
    buttons
  } = data || {
    fields: []
  };
  return /*#__PURE__*/_jsx(Render, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "login-page2-inner",
      children: [/*#__PURE__*/_jsx("aside", {
        children: blocks.banner
      }), /*#__PURE__*/_jsxs("main", {
        children: [/*#__PURE__*/_jsxs("header", {
          children: [blocks.logo, " ", blocks.title]
        }), fields.sort((a, b) => a.index - b.index).map((item, idx) => {
          if (!item.children) return null;
          return /*#__PURE__*/_jsxs("label", {
            className: "rlp-" + item.name,
            children: [item.children, " ", extra[item.name]]
          }, item.name + idx);
        }), /*#__PURE__*/_jsx("section", {
          children: buttons.sort((a, b) => a.index - b.index).map((item, idx) => {
            var child = item.children;
            if (! /*#__PURE__*/isValidElement(child)) return null;
            return /*#__PURE__*/cloneElement(child, _extends({}, child.props, {
              key: item.name + idx
            }));
          })
        }), blocks.buttonAfter]
      })]
    })
  });
};
var LoginPage = /*#__PURE__*/forwardRef((props, ref) => {
  var {
      children,
      className
    } = props,
    divProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs(Provider, {
    children: [/*#__PURE__*/_jsx(Banner, {}), /*#__PURE__*/_jsx(Email, {}), /*#__PURE__*/_jsx(Password, {}), /*#__PURE__*/_jsx(Logo, {}), /*#__PURE__*/_jsx(Title, {}), /*#__PURE__*/_jsx(Submit, {}), /*#__PURE__*/_jsx(Container, _extends({}, divProps, {
      ref: ref,
      className: "login-page2 " + (className || ''),
      children: /*#__PURE__*/_jsx(RenderLogin, {})
    })), children]
  });
});
var Login = LoginPage;
Login.Email = Email;
Login.Password = Password;
Login.Submit = Submit;
Login.Reset = Reset;
Login.ButtonAfter = ButtonAfter;
Login.Logo = Logo;
Login.Banner = Banner;
Login.Title = Title;
Login.displayName = 'LoginPage';
export default Login;